<template>
    <div class="zui-wrapper">
    <div class="zui-scroller" ref="scroller" @scroll="scrollX">
        <table class="zui-table-boarded table font-15">
            <thead>
                <tr ref="header">
                    <template v-for="(col, index) in selected_columns">
                        <th
                            v-if="col.show"
                            class="pointer text-nowrap"
                            :class="{'zui-sticky-col': index == 0}"
                            @click="sortBy(col.column)"
                            :key="col.column"
                            :colspan="stat_compared.length > 0 ? col.colspan : 1"
                            v-b-tooltip.hover
                            :title="col.title"
                            :ref="col.column + 'ref'"
                        >
                            {{col.i18n}}
                            <img v-if="col.showArrowUpForSortedColumn" src="/img/sprites/ButtonMailLesen.png" />
                            <img v-if="col.showArrowDownForSortedColumn" src="/img/sprites/ButtonMailGeLesen.png" />

                        </th>
                    </template>
                    <th class="pointer" @click="show_selected_list = !show_selected_list">
                        <font-awesome-icon icon="bars"/>
                    </th>
                </tr>
                <tr class="fixed" v-if="fix" :style="style" ref="fixed">
                    <template v-for="(col, index) in selected_columns">
                        <th
                            class="pointer text-nowrap"
                            :class="{'zui-sticky-col': index == 0}"
                            @click="sortBy(col.column)"
                            :key="col.column"
                            :colspan="stat_compared.length > 0 ? col.colspan : 1"
                            v-b-tooltip.hover
                            :title="col.title"
                            v-if="col.column != 'id' && col.show"
                            :style="getWidth(col.column)"
                        >
                            {{col.i18n}}
                            <img v-if="col.showArrowUpForSortedColumn" src="/img/sprites/ButtonMailGeLesen.png" />
                            <img v-if="col.showArrowDownForSortedColumn" src="/img/sprites/ButtonMailLesen.png" />
                        </th>
                    </template>
                    <th class="pointer" @click="show_selected_list = !show_selected_list">
                        <font-awesome-icon icon="bars"/>
                    </th>
                </tr>
                <tr>
                    <th class="zui-sticky-col">Gesamt ({{total.object_count}})</th>
                    <template v-for="col in selected_columns">
                        <th
                            v-if="col.column != 'id' && col.show"
                            :colspan="total_compared && Object.keys(total_compared).length > 0 ? col.colspan : 1"
                            :key="col.column"
                        >
                            <template v-if="col.column == 'status' || col.column == 'name'">
                                &nbsp;
                            </template>
                            <template v-else>
                                {{total[col.column] ? thousandOperator(total[col.column]) : '-'}}
                            </template>
                        </th>
                    </template>
                    <th>&nbsp;</th>
                </tr>
                <tr v-if="total_compared && Object.keys(total_compared).length > 0" class="compare">
                    <th class="zui-sticky-col compare">Gesamt ({{total_compared.object_count}})</th>
                    <template v-for="col in selected_columns">
                        <th
                            v-if="col.column != 'id' && col.show"
                            :colspan="col.colspan"
                            :key="col.column"
                        >
                            <template v-if="col.column == 'status' || col.column == 'name'">
                                &nbsp;
                            </template>
                            <template v-else>
                                {{total_compared[col.column] ? thousandOperator(total_compared[col.column]) : '-'}}
                            </template>
                        </th>
                    </template>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(stat, index) in statistics" :key="stat.id">
                    <template v-for="col in selected_columns">
                        <template v-if="col.show">
                            <td v-if="col.column =='status'" :key="col.column">
                                <font-awesome-icon icon="check" v-if="stat.status == 'ok'" class="mm-color"/>
                                <font-awesome-icon icon="lock"      v-else class="mm-color-orange"/>
                            </td>
                            <td v-else-if="col.column == 'id'" :key="col.column" class="zui-sticky-col">
                                <a href="#"  @click.prevent="showObject(stat[col.column])" class="mm-link">{{stat[col.column]}}</a>
                            </td>
                            <td v-else-if="col.column == 'improvements'" :key="col.column">
                                <template  :disabled="stat[col.column] == 0" :id="'show_zo_' + stat.id">
                                    {{stat[col.column]}}
                                </template>
                                <b-tooltip :target="'show_zo_' + stat.id" v-if="stat[col.column] > 0">
                                    <div v-for="improvement in showImprovements(stat.id)">
                                        {{$t('intern_objekte_list.mit_' + improvement.packet_key)}}
                                    </div>
                                </b-tooltip>
                            </td>
                            <td v-else-if="col.column == 'name'" :key="col.column" :id="'name_' + stat.id">
                                <template v-if="stat[col.column].length <= 50">
                                    {{stat[col.column]}}
                                </template>
                                <template v-else>
                                        {{stat[col.column].substring(0, 50) + '....'}}
                                    <b-tooltip :target="'name_' + stat.id">
                                        {{stat[col.column]}}
                                    </b-tooltip>
                                </template>
                            </td>
                            <td v-else :key="col.column" :id="col.column + index">
                              {{isNaN(stat[col.column]) ? stat[col.column]: thousandOperator(stat[col.column]) }}
                            </td>
                            <template v-if="stat_compared.length > 0 && col.colspan > 1">
                                <td v-if="col.column =='status'" class="compare">
                                    <font-awesome-icon icon="check" v-if="stat_compared[index].status == 'ok'" class="mm-link"/>
                                    <font-awesome-icon icon="lock"      v-else class="mm-color-orange"/>
                                </td>
                                <td v-else class="compare">
                                    {{stat_compared[index][col.column]}}
                                    <b-tooltip :target="col.column + index" triggers="hover">
                                        {{getDecreasePercentage(stat[col.column], stat_compared[index][col.column])}}
                                    </b-tooltip>
                                </td>
                            </template>
                        </template>
                    </template>
                    <td>
                        <router-link :to="{name: 'inserat-edit', params: {id: stat.id}}" class="text-secondary" target="_blank" v-b-tooltip.hover title="Zur Bearbeitung Ihres Inserats">
                            <font-awesome-icon icon="edit"/>
                        </router-link>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
        <div v-if="show_selected_list">
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="show_selected_list = false">
                <span aria-hidden="true">&times;</span>
            </button>
            <ul class="list-group dd-down">
                <template v-for="col in all_columns">
                    <li v-if="col.show" @click="addToList(col)" :key="col.column" class="list-group-item pointer">
                        <label>
                            <font-awesome-icon icon="check-square" class="mm-color" v-if="isInSelectedList(col)"/>
                            <font-awesome-icon icon="square"       class="mm-color" v-else/>
                            {{col.i18n}}
                        </label>
                    </li>
                </template>
            </ul>
        </div>
        <b-modal ref="object_preview" hide-footer size="lg">
            <template v-slot:modal-title v-if="object">
                Inserats-Nummer #{{object.id}}
            </template>
            <object-component v-if="object" :object="object"/>
        </b-modal>
    </div>
</template>

<script>
    import ObjectComponent from '../object/Object';
    import EventBus        from '../../EventBus';
    import { IsMobileMixin } from '../../mixins/IsMobile';

    export default {
        data() {
            return {
                show_selected_list: false,
                all_columns: [
                    {
                        column: 'id',
                        title: this.$t('intern_statistics.title_id'),
                        colspan: 1, i18n: 'Inseratsnr.', show: true, order: 0,
                        showArrowDownForSortedColumn : false , showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'name',
                        title: this.$t('intern_statistics.title_name'),
                        colspan: 1, i18n: 'Titel', show: true, order: 1,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'status',
                        title: this.$t('intern_statistics.title_status'),
                        colspan: 1, i18n: 'Status', show: true, order: 2,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'aufrufe',
                        title: this.$t('intern_statistics.title_aufrufe'),
                        colspan: 2, i18n: 'Aufrufe', show: true, order: 3,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'anfragen',
                        title: this.$t('intern_statistics.title_anfragen'),
                        colspan: 2, i18n: 'Schriftliche Anfragen', show: true, order: 4,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'telefon',
                        title: this.$t('intern_statistics.title_telefon'),
                        colspan: 2, i18n: 'Telefonische Anfragen', show: true, order: 5,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'deeplink',
                        colspan: 2, i18n: 'Deeplinks', show: this.has_deeplink, order: 6,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'impressum',
                        title: this.$t('intern_statistics.title_impressum'),
                        colspan: 2, i18n: 'Impressum Klicks', show: true, order: 7,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'created_at',
                        title: this.$t('intern_statistics.title_created_at'),
                        colspan: 1, i18n: 'Erstellungsdatum', show: true, order: 8,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    // {
                    //     column: 'updated_at',
                    //     colspan: 1, i18n: 'Änderungsdatum', order: 8
                    // },
                    {
                        column: 'improvements',
                        title: this.$t('intern_statistics.title_improvements'),
                        colspan: 1, i18n: 'Zusatzleistungen', show: true, order: 9,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'category',
                        title: this.$t('intern_statistics.title_category'),
                        colspan: 1, i18n: 'Kategorie', show: true, order: 10,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'conversion_rate_anfragen',
                        title: this.$t('intern_statistics.title_conversion_rate_anfragen'),
                        colspan: 2, i18n: 'Conversionrate - Anfragen', show: true, order: 11,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {
                        column: 'conversion_rate_telefon',
                        title: this.$t('intern_statistics.title_conversion_rate_telefon'),
                        colspan: 2, i18n: 'Conversionrate - Telefon', show: true, order: 12,
                        showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false
                    },
                    {column: 'conversion_rate_deep_link', colspan: 2, i18n: 'Conversionrate - Deeplink', show: this.has_deeplink, order: 13, showArrowDownForSortedColumn : false, showArrowUpForSortedColumn : false},
                ],
                selected_columns : [],
                object: null,
                object_packets: null,
                fix: false,
                style: {}
            }
        },
        mixins: [IsMobileMixin],
        props: ['statistics', 'total', 'stat_compared', 'total_compared', 'has_deeplink'],
        components: {
            ObjectComponent
        },
        methods: {
            thousandOperator(number){
              let nf = new Intl.NumberFormat('de-DE');
              return nf.format(number);
            },
            sortBy(sort) {
                this.$emit('sort', sort);

                for (var index = 0; index < this.selected_columns.length; index++) {
                  if (this.selected_columns[index].column == sort) {
                    if (this.selected_columns[index].showArrowUpForSortedColumn === true) {
                      this.selected_columns[index].showArrowUpForSortedColumn = false;
                      this.selected_columns[index].showArrowDownForSortedColumn = true;
                    } else {
                      this.selected_columns[index].showArrowUpForSortedColumn = true;
                      this.selected_columns[index].showArrowDownForSortedColumn = false;
                    }
                  }
                  else {
                    this.selected_columns[index].showArrowUpForSortedColumn = false;
                    this.selected_columns[index].showArrowDownForSortedColumn = false;
                  }
                }
            },
            addToList(col) {
                if(col.column == 'id'){
                    return;
                }
                let found = this.isInSelectedList(col);
                if(!found) {
                    this.selected_columns.push(col);
                }else {
                    this.selected_columns = this.selected_columns.filter(item => item.column != col.column);
                }

                this.selected_columns = this.selected_columns.sort((el1, el2) => {
                    if(el1.order < el2.order){
                        return -1;
                    }
                    else if(el1.order > el2.order){
                        return 1;
                    }
                    else {
                        return 0;
                    }
                });
            },
            isInSelectedList(col) {
                if(typeof col === 'string'){
                    return this.selected_columns.find(item => item.column == col);
                }else {
                    return this.selected_columns.find(item => item.column == col.column);
                }
            },
            showObject(id) {
                this.$store.state.loading = true;
                this.$http.get('/ObjectApi/getObjectForPreview?id=' + id).then(response => {
                    this.object = JSON.parse(response.data);
                    this.$refs.object_preview.show();
                }).catch(error => {
                    console.log(error);
                }).then(() => {
                    this.$store.state.loading = false;
                })
            },
            showImprovements(id) {
                if(this.object_packets){
                    let improvements = [];
                    improvements     = this.object_packets.filter(item => item.object_id == id);
                    return improvements;
                }
            },
            getDecreasePercentage(oldVal, newVal){
                if(oldVal == 0 && newVal == 0) {
                    return '0%';
                }

                if(oldVal == 0){
                    return Number(newVal) * -100 + '%';
                }

                if(newVal == 0){
                    return Number(oldVal) * 100 + '%';
                }

                let percent = ((Number(oldVal)/Number(newVal)) - 1 ) * 100;
                return Math.round(percent * 100) / 100 + '%';
            },
            showColumnIfFiltersAreSelected(col){
                let column = this.selected_columns.find(item => item.column == col);
                if(!column){
                    column = this.all_columns.find(item => item.column == col);
                    this.selected_columns.push(column);
                }
            },
            fixedHeaderOnScrolling(event) {
                let el = this.$refs.header;

                var top = el.offsetTop;
                var height = el.offsetHeight;

                while(el.offsetParent) {
                    el = el.offsetParent;
                    top += el.offsetTop;
                }

                this.style.width = this.$refs.scroller.clientWidth + 'px';
                if(
                    top >= window.pageYOffset &&
                    (top + height) <= (window.pageYOffset + window.innerHeight)
                ){
                    this.fix = false;
                }else {
                    this.fix = true;
                }
            },
            getWidth(col) {
                return {'min-width': this.$refs[col+'ref'][0].clientWidth + 'px !important'}
            },
            scrollX() {
                if(this.fix){
                    this.$refs.fixed.scrollLeft = this.$refs.scroller.scrollLeft;
                }
            }
        },
        created() {
            this.object_packets = this.$store.getters.object_packets;

            this.$store.watch(() => {
                return this.$store.getters.object_packets;
            }, object_packets => {
                this.object_packets   = object_packets;
            });

            if(!this.object_packets) {
                this.$store.dispatch('OBJECT_PACKETS');
            }
            this.selected_columns = this.all_columns.filter(el => el.show).slice(0,7);

            EventBus.$on('ADD_COLUMN', this.showColumnIfFiltersAreSelected);
            window.addEventListener('scroll', this.fixedHeaderOnScrolling);
        },
        destroyed() {
            EventBus.$off('ADD_COLUMN', this.showColumnIfFiltersAreSelected);
            window.removeEventListener('scroll', this.fixedHeaderOnScrolling);
        }
    }
</script>

<style scoped>
.dd-down{
    position: absolute;
    right: 0;
    top: 40px;
    max-height: 300px;
    max-width: 280px;
    overflow-y: auto;
    border: 1px solid rgba(0,0,0,.125);
    padding: 0;
    z-index: 5;
}
.close{
    position: absolute;
    top: 50px;
    right: 25px;
    z-index: 6;
}
.compare{
    background: #ebebeb;
    color: #8faadc;
}
.table thead th {
    vertical-align: top;
}
.zui-table-boarded {
    border-collapse: separate;
    border-spacing: 0;
    overflow-x: unset;
    position: absolute;
}
.zui-table thead th {
    padding: 10px;
    text-align: left;
    white-space: nowrap;
}
.zui-table tbody td {
    padding: 10px;
    text-shadow: 1px 1px 1px #fff;

}
.zui-wrapper {
    position: relative;
    height: 480px;
    overflow-y: scroll;
}
.zui-scroller {
    /*margin-left: 120px;*/
    /*overflow-x: auto;*/
    overflow-y: visible;
    padding-bottom: 5px;
}
.zui-table .zui-sticky-col {
    left: 0;
    position: absolute;
    top: auto;
    width: 120px;
}
thead{
    position: relative;
}
.fixed{
    margin-left: 120px;
    position: fixed;
    top: 0;
    overflow-x: hidden;
    overflow-y: visible;
    max-width: 100%;
    background-color: white;
    z-index: 1;
}
.right{
    right: 350;
}
</style>
